// src/theme/self-hosted-fonts.js
//
// Font families the portal ships itself (spec 20260930-caro-editorial-theme, T038, NFR-1).
// ThemeContext never asks Google Fonts for these — not under Editorial, and not when a user picks
// the plain "Nunito" typography under another theme either. The @font-face rules live in
// ./fonts.css, loaded once from src/index.js through ./fonts.js.
export const SELF_HOSTED_FONTS = [
  'Nunito Variable',
  'Nunito',
  'Newsreader Variable',
  'Newsreader',
  'JetBrains Mono',
];

/** First family of a CSS font-family list, unquoted: '"Nunito Variable", sans-serif' → 'Nunito Variable'. */
export const primaryFamily = (fontFamily = '') =>
  String(fontFamily).split(',')[0].trim().replace(/^["']|["']$/g, '');

export const isSelfHostedFont = (fontFamily) => SELF_HOSTED_FONTS.includes(primaryFamily(fontFamily));
